<template>
  <el-container>
    <el-header>
      <Navbar ></Navbar>
    </el-header>
    <el-container class="main_cont">
      <el-main style="height: 100% ;padding: 0;">
        <el-container style="height: 100% ;">

          <el-aside width="100%" class="history">
            <div style="position: absolute;top: 0px;right: 0;width: 248px;height: 36px;top: 38px;right: 100px;" v-if="activeName==0">
              <el-input placeholder="搜索用户名" @change="searchChange" v-model="searchValue" style="z-index: 99;" class="search_input">
                <template slot="append">
                  <i class="el-icon-search"></i>
                </template>
              </el-input>
            </div>

            <el-tabs v-model="activeName" style="height: 100%;">
              <el-tab-pane label="关注" name="0" style="height: 100%;position: relative;">
                <span slot="label">
                  <div class="title t1"><span>关注</span></div>
                </span>
                <div class="scroll-cont"
                  style="scrollbar-width: none;overflow-y: auto;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #828292 ;box-sizing: border-box;">
                  <div v-if="his_list.length == 0"
                    style="color: gray;text-align: center;margin-top: 8px;font-size: 16px;height: 100%;display: flex;align-items: center; justify-content: center;">
                    <div class="empty" style="position: relative;text-align: center;color: #49495A;"
                      :style="{  width: 300 + 'px' , height: 300 + 'px' }"
                    >
                      <el-image :style="{ height: 200 + 'px' , width: 200 + 'px'  }"
                        :src="require('../assets/img/DrawingBoard/empty.png')"
                          fit="contain">
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      <div>暂无关注，去 <span @click="goHome" style="color: #006FFF; margin: 0 5px;cursor: pointer;">首页</span> 寻找灵感吧～</div>
                    </div>
                  </div>
                  <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" :finished="finished" :finished-text="' '"
                    class="his_item_container">
                    <div v-for="(item, i) in his_list" :key="i" class="his-item "
                      style="display: flex;position: relative;" 
                      
                      >
                      <div style="width: 80px; height: 80px;margin-right: 20px;flex-shrink: 0;position: relative;" @click="gotoPersonal(item)">
                        <el-image style="width: 80px; height: 80px;border-radius: 50%;;flex-shrink: 0;"
                          v-if="item.accountModel.photo"
                          :src="item.accountModel.photo"
                            fit="cover">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image style="width: 80px; height: 80px;border-radius: 50%;;flex-shrink: 0;"
                          v-else
                          :src="require('../assets/img/ava.png')"
                            fit="cover">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <div style="position:absolute;display:inline-block;right:-21px;top:-11px;width: 42px;height: 22px;line-height: 22px;text-align: center;background: #EF4545;border-radius: 13px 13px 13px 0px;font-size: 12pxfont-weight: 500;color: #FFFFFF;" v-if="item.hasUpdate">更新</div>
                      </div>
                      <div class="c">
                        <div class="ct">
                          <div class="ct_name" @click="gotoPersonal(item)">
                            {{ item.accountModel.uname }}
										        <el-image style="width: 26px;height: 14px;margin-left: 4px;" :src="require('../assets/img/waterfall/vip.png')"  class="vip" v-if="item.accountModel.vip"></el-image>
                          </div>
                        </div>
                        <div class="cb">
                          {{  item.paintingCount }}作品·{{  item.fsCount }}粉丝
                        </div>
                        <div class="btnUnfocus" v-if="item.notGz" @click.stop="addGz(item ,i)">
                          关注
                        </div>
                        <div  class="btnfoucs" style="background: #EF4545;color: #FFFFFF" v-else-if="item.showMove" @click.stop="cancelGz(item,i)" @mouseover="changeIndex(i)" @mouseout="changeIndexBack(i)">
                          取消关注
                        </div>
                        <div class="btnfoucs" v-else-if="item.gz" @click.stop="cancelGz(item,i)" @mouseover="changeIndex(i)" @mouseout="changeIndexBack(i)">
                          互关
                        </div>
                        <div class="btnfoucs" v-else="!item.gz"  @click.stop="cancelGz(item,i)" @mouseover="changeIndex(i)" @mouseout="changeIndexBack(i)">
                          已关注
                        </div>
                      </div>
                      <div class="img_cont">
                        <el-image class="_img" :src="item.url" v-for="item in item.userPaintingList"  @click.stop="itemToDetail(item)"></el-image>
                      </div>
                    </div>
                  </vue-loadmore>
                </div>
              </el-tab-pane>
              <el-tab-pane label="粉丝" name="1" style="height: 100%;">
                <span slot="label">
                  <div class="title t2"><span>粉丝</span></div>
                </span>
                <div class="scroll-cont"
                  style="scrollbar-width: none;overflow-y: auto;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #828292 ;box-sizing: border-box;">
                  <div v-if="his_list.length == 0"
                    style="color: gray;text-align: center;margin-top: 8px;font-size: 16px;height: 100%;justify-content: center;align-items: center;display: flex;">
                    <div class="empty" style="position: relative;text-align: center;color: #49495A;"
                      :style="{  width: 300 + 'px' , height: 300 + 'px' }"
                    >
                      <el-image :style="{ height: 200 + 'px' , width: 200 + 'px'  }"
                        :src="require('../assets/img/DrawingBoard/empty.png')"
                          fit="contain">
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      <div>暂无粉丝，去 <span @click="goHome" style="color: #006FFF; margin: 0 5px;cursor: pointer;">首页</span> 寻找灵感吧～</div>
                    </div>
                  
                  </div>
                    <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" :finished="finished" :finished-text="' '"
                    class="his_item_container">
                    <div v-for="(item, i) in his_list" :key="i" class="his-item "
                      style="display: flex;position: relative;" 
                      
                      >
                      <div style="width: 80px; height: 80px;margin-right: 20px;flex-shrink: 0;" @click="gotoPersonal(item)">
                        <el-image style="width: 80px; height: 80px;border-radius: 50%;;flex-shrink: 0;"
                          v-if="item.accountModel.photo"
                          :src="item.accountModel.photo"
                            fit="cover">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image style="width: 80px; height: 80px;border-radius: 50%;;flex-shrink: 0;"
                          v-else
                          :src="require('../assets/img/ava.png')"
                            fit="cover">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </div>
                      <div class="c">
                        <div class="ct" @click="gotoPersonal(item)">
                          <div class="ct_name">
                            {{ item.accountModel.uname }}
										        <el-image style="width: 26px;height: 14px;margin-left: 4px;" :src="require('../assets/img/waterfall/vip.png')"  class="vip" v-if="item.accountModel.vip"></el-image>
                          </div>
                        </div>
                        <div class="cb">
                          {{  item.paintingCount }}作品·{{  item.fsCount }}粉丝
                        </div>
                        <div class="btnfoucs" v-if="item.focus" @click.stop="fensicancelGz(item ,i)"  @mouseover="changeIndex(i)" @mouseout="changeIndexBack(i)">
                          已回关
                        </div>
                        <div class="btnUnfocus" v-else @click.stop="fensiAddGz(item,i)" >
                          回关
                        </div>

                      </div>
                      <div class="img_cont">
                        <el-image class="_img" :src="item.url" v-for="item in item.userPaintingList" @click.stop="itemToDetail(item)"></el-image>
                      </div>
                    </div>
                  </vue-loadmore>
                </div>
              </el-tab-pane>
            </el-tabs>
            <!-- -->
          </el-aside>
        </el-container>
      </el-main>
    </el-container>


  </el-container>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import SensitiveCont from "@/components/SensitiveCont"
import imageImageForm from "@/components/imageImageForm";


import { chat_sensitiveKeywords_req } from "@/api/qa";
import {  img_page_req, task_interrupt_req, task_status_req, task_running_req, task_undoTask_req , img_del , painting_removeByTid} from "@/api/taskImage";
import { add_task_req , task_interrogate_req } from "@/api/imageImage";
import { getSocketUrl, getToken, handleDownloadQrIMg } from "@/utils/bose";
import { user_account_req } from "@/api/user";
import { painting_page_req , painting_publish_req , painting_history_req , painting_cancel_req } from "@/api/personal";
import {  interest_fsPage_req ,interest_gzPage_req , interest_edit_req, interest_read_req }  from "@/api/group";


export default {
  name : 'MyGroup', 
  components: {
    Navbar,
    NavbarLeft,
    imageImageForm,
    SensitiveCont
  },
  data() {
    return {

      recData: [],
      text: '',
      text2: '',
      loading: false,
      picselected: [], // Must be an array reference!
      show: false,
      bodyBgVariant: 'dark',
      tools_show: false,

      progress_value: 0,
      img_create_loading: false,
      needSec: undefined,
      needSecStep: undefined,
      timer: null,
      imgList: [],
      imgIdx: 0,

      // 下拉滚动相关
      pageNum: 1,
      pageSize: 20,
      his_list: [],
      finished: false,
      // 下拉滚动相关

      activeName:  undefined ,
      ac_data: {},//账户信息
      searchValue :  undefined ,
    }
  },
  onLoad(){

  },
  async mounted() {
    if (this.tokenVuex) {
      let _this = this ;
      if( this.$route.params.activeName ){
        this.activeName = this.$route.params.activeName.toString()
      }

      // if( this.$route.params && this.$route.params.activeName ){ 
      //   if( this.$route.params.activeName == "0" ) this.$route.params.activeName = 0 ;

      // }

      await this.getUserAccountInfo() //获取账户信息
    } else {
      this.$toast.open({
        message: "请先登录噢",
        position: 'top',
        duration: 3000,
        queue: true,
        type: 'error',
      })
    }

  },
  beforeDestroy() {

  },
  destroyed() {
    //离开路由之后断开websocket连接
    // this.websock.close();
  },
  computed: {
    formVuex: {
      get() {
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.imageImage.form
      },
      set(newVal) {
        this.formVuex = newVal;
      }
    },
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token
    },
  },
  methods: {

    deleteHis(i) {
      if (this.img_create_loading) {
        return;
      }
      let taskId = this.his_list[i].taskId;
      this.$confirm('', '删除此条记录，您的作品也将一并删除，是否删除?', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        center: true,
        customClass: "_message_box2"
      }).then(({ value }) => {
        painting_removeByTid(taskId).then(res => {
          this.$toast.open({
            message: '已删除',
            position: 'top',
            duration: 3000,
            type: 'success',
          });
          
          try {
            if( this.his_list[i].list[0].md5 && this.imgList[0].md5 && (  this.his_list[i].list[0].md5 == this.imgList[0].md5  )  ){
               this.imgList = []
            }
          } catch (error) {
            console.error(error);
          }
          this.his_list.splice(i, 1);
        })
      }).catch(() => {
        // this.$toast.open({
        //     message: '删除失败，请稍后再试',
        //     position: 'top',
        //     duration: 1000,
        //     type: 'error',
        //   });
      });
    },

    // 历史记录相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.img_page_get();
      done();
    },
    onLoad(done) {
      if( this.activeName == 0 ){
        this.img_page_get( 0 );
      } else {
        this.img_page_get( 1 );
      }
      done();
    },
    // 获取历史记录
    img_page_get( val , searchvalue ) {
      if (!this.tokenVuex) {
        return;
      }
      this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 1)' ,
        customClass : "my_loading" 
      });

      let _this = this ;
      if( val == 0){
        interest_gzPage_req({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          uname : searchvalue ? searchvalue : undefined ,
        }).then(res => {
          if (res.success) {
            
            this.his_list = this.his_list.concat(res.data.records);
            if (this.pageNum >= res.data.pages) {
              this.finished = true;
              return
            }
            this.pageNum++;
          } else {
            this.his_list = [];
            this.pageNum = 1;
          }
        }).catch().finally( ()=>{
          _this.$loading().close()
        })
      } else if(val == 1){
        interest_fsPage_req({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }).then(res => {
          if (res.success) {
            this.his_list = this.his_list.concat(res.data.records);
            if (this.pageNum >= res.data.pages) {
              this.finished = true;
              return
            }
            this.pageNum++;
          } else {
            this.his_list = [];
            this.pageNum = 1;
          }
        }).catch().finally( ()=>{
          _this.$loading().close()
        })
      }  

    },

    // 历史记录相关 //
    async getUserAccountInfo() {
      const { data, success } = await user_account_req()
      if (success) {
        this.ac_data = data
      }
    },
    addGz( item , i ){
      interest_edit_req({
        status : 1 ,
        fid :item.accountModel.uid
      }).then( res => {
        if( !res.data  ) return ;
        this.his_list[ i ].notGz = false  ;
        this.$forceUpdate()
      })
    },
    cancelGz( item , i  ){
      interest_edit_req({
        status : 2 ,
        fid :item.accountModel.uid
      }).then( res => {
        if( !res.data  ) return ;
        this.his_list[ i ].notGz = true ;
        this.$forceUpdate()

      })
    } ,
    fensiAddGz(item , i){
      interest_edit_req({
        status : 1 ,
        fid :item.accountModel.uid
      }).then( res => {
        if( !res.data  ) return ;
        this.his_list[ i ].focus = true ;
        this.$forceUpdate()
      })
    },
    fensicancelGz(item , i){
      interest_edit_req({
			status : 2 ,
			fid :item.accountModel.uid
		}).then( res => {
      if( !res.data  ) return ;
        this.his_list[ i ].focus = false ;
        this.$forceUpdate()
		})
    } ,
    changeIndex(e){
        this.his_list[e].showMove = true ;
        this.$forceUpdate()
        // this.imgList[e].show = !this.imgList[e].show
    },
    changeIndexBack(e){
        this.his_list[e].showMove = false ;
        this.$forceUpdate()
        // this.imgList[e].show = !this.imgList[e].show
    },
    gotoPersonal( item ){
      let obj = {} ;
      obj.router = "personal"  ;
      obj.uid = item.accountModel.uid ;
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj
      });
    },
    goHome(){
      this.$router.push({
        path : "/"
      })
    },
    itemToDetail(item){
      console.log( item )
      let obj = {}
      obj.router = "explore"
      obj._id = item.id
      this.$router.push({
        name: "test", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: obj
      });
    } ,
    searchChange(e){
      this.his_list = [];
      this.pageNum = 1 ;
      this.img_page_get(0 , e );

    }
  },
  watch: {
    tokenVuex(newQuestion, oldQuestion) {
      // console.log( newQuestion  )
      if (!newQuestion) {
        this.$router.replace({
          name: "home", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            unlogin: true
          }
        });
      }
    },


    activeName( newVal ){
      this.his_list = [];
      this.pageNum = 1 ;
      if( newVal == 0 ){
        this.img_page_get(0);
      } else {
        this.img_page_get(1);
      }

    },

  },
}
</script>



<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}

::v-deep .el-tabs__item {
  color: #CACAD4;
  font-weight: 400;
  padding: 0;
}
::v-deep .el-tabs__nav {
  margin-left: 72px;
}
::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #0B0B1e;
  height: 0;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

/*修改.el-progress背景色*/
::v-deep .el-progress-circle__track {
  stroke: #38394b;
}

::v-deep .modal-class {
  position: relative;
  min-height: 200px;
}

::v-deep .modal-class .chevron-left {
  position: absolute;
  left: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
}

::v-deep .modal-class .chevron-right {
  position: absolute;
  right: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
  z-index: 999;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-textarea__inner {
  background: #222337;
  border: none;
  color: #fff;

  &::placeholder {
    color: #49495A;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #49495A;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #49495A;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: #49495A;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: #49495A;
  }
}
::v-deep .el-slider__bar {
  background-color: #006FFF;
}

.container-fluid {
  // background-color: #f5f6f9;
  padding-left: 5px;
  padding-right: 5px;
  height: calc(100%);

}

::v-deep .main_cont {
  height: calc(100vh - 66px);
  background: #0B0B1F;
  .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
    background-color: #0b0b1f !important;
  }

    
  .upload-file .el-upload-list .el-upload-list__item:hover .el-icon-close {
    display: none;
  }
}

.content {
  box-sizing: border-box;
  // background-color: #f5f6f9;
  height: 100%;

  .toolbox {
    text-align: left;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
    overflow: hidden;
    height: 100%;
    padding-right: 20px;
    /* 防止滚动条遮挡内容 */

    .toolbox_cont {}

    .title {
      font-weight: 700;
      color: #333;
      padding-bottom: 8px;
      border-bottom: 2px solid #317cf6;
    }

    .icon-item {
      width: 25%;
      margin-bottom: 12px;

      .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #51a280;
        margin: 0 auto;
      }

      .name {
        font-size: 12px;
        text-align: center;
        margin-top: 3px;
      }
    }
  }

  .toolbox {
    overflow: hidden;
  }

  .toolbox::-webkit-scrollbar {
    width: 1px;
    display: flex;
  }

  .toolbox::-webkit-scrollbar-thumb {
    background: #3ba9f8;
  }

  .toolbox:hover {
    overflow-y: auto;
    width: calc(100% - 1px)
  }

  .tool-main {
    .tool-main-cont {
      justify-content: center;
      align-items: center;
      height: 450px;
      width: 450px;
      margin: 0 auto;
      // background-color: #006FFF;
      background-image: url("../assets/img/textform/bg.png");
      flex-direction: column;
    }
  }

  .getpromptBtn {
    width: 120px;
    height: 30px;
    background: #0B0B1F;
    border-radius: 14px;
    border: 1px solid #006FFF;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #006FFF;
    line-height: 28px;
  }
}

.eraser_type {
  cursor : url("../assets/img/textform/eraser1.png" ) 12 12 ,auto;
  
}
.pen_type {
  cursor : url("../assets/img/textform/pen1.png" ) 12 12 ,auto;
}


.img-cont {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #f5f6f9;
  margin: 0 auto;

}

.bottom-cont {
  box-sizing: border-box;
  border: none;
  max-height: 124px;
  padding: 10px 0;
  //min-height: 66px;
  background: #222337;
  border-radius: 10px;

  textarea {
    border: none;
    resize: none;
    cursor: pointer;
  }
}


.history {
  text-align: left;
  padding: 12px;
  padding-top: 40px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #0B0B1F;
  position: relative;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006FFF;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 23px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 23px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px ;
  }

  .scroll-cont {
    height: calc(100% );
    position: relative;
  }

  .scroll-cont {
    overflow: hidden;
  }

  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }

  .scroll-cont::-webkit-scrollbar-thumb {}

  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }
  .his_item_container {
    padding: 0 100px 0 84px;
  }
  .his-item {
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 148px;
    margin-bottom: 5px;
    align-content: stretch;
    position: relative;
    overflow: hidden;
    padding-bottom: 24px;
    padding-top: 28px;
    border-bottom: 1px solid #252739;
    .imgB1 {
      width: 130px;
      height: 130px;
    }

    .imgB2 {
      width: 65px;
      height: 130px;
    }

    .imgB3 {
      width: 65px;
      height: 65px;
    }

    .imgB4 {
      width: 65px;
      height: 65px;
    }

    img {
      width: 50%;
      height: 50%;
    }
    .top_model {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
      z-index: 10;
      display: none;
    }
    .deleteIcon {
      display: none;
    }


    .c {
				flex: 1;
				.ct {
					display: flex;
					align-items: center;
					height: 40rpx;
					.ct_name {
						height: 28px;
						width: 100%;
						font-size: 20px;
						font-weight: 500;
						line-height: 28px;
						display: flex;
						align-items: center;
						overflow:hidden; //超出的文本隐藏
						text-overflow:ellipsis; //溢出用省略号显示
						white-space:nowrap; //溢出不换行
            color: #fff;
					}
				}
				.cb {
          height: 22px;
          font-size: 16px;
					color: #9A9AB7;
					line-height: 22px;
					margin-top: 2px;
          margin-bottom: 10px;
				}
			}
      .img_cont {
        height: 100px;
        display: flex;
        ._img {
          margin-left: 6px;
          width: 100px;
          height: 100px;
        }
        ._img:first-child {
          border-radius: 10px 0px 0px 10px;
        }
        ._img:last-child {
          border-radius: 0px 10px 10px 0px;
        }
      }
			.btnfoucs {
				width: 88px;
				height: 34px;
				line-height: 34px;
				background: #252739;
				border-radius: 17px;
				text-align: center;
				line-height: 34px;
				font-size: 16px;
				font-weight: 500;
				color: #9A9AB7;
			}
			.btnUnfocus {
				width: 88px;
				height: 34px;
				background: linear-gradient(315deg, #006FFF 0%, #72E3F5 100%);
				border-radius: 17px;
				text-align: center;
				line-height: 34px;
				font-size: 16px;
				font-weight: 500;
				color: #FFFFFF;
			}
  }

  .his-item:hover {
    .top_model {
      display: block;;
    }
    .deleteIcon {
      display: block;
    }
  }
}


.carousel-cont .carousel-caption {
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
}

.exit_hover .arrowClickIcon{display:none;}
.exit_hover:hover .arrowClickIcon{display:inline-block;}

::v-deep .search_input {
  .el-input__inner {
    background-color: #252739;
    border-radius: 18px 0 0 18px;
    border: none;
    color: #9A9AB7;
    &::placeholder {
        color: #9A9AB7;
    }

  }
  .el-input-group__append {
    background-color: #252739;
    border: none;
    border-radius: 0 18px 18px 0 ;
  }
}

</style>  